import { render, staticRenderFns } from "./Amelia.vue?vue&type=template&id=7c74d5de"
import script from "./Amelia.vue?vue&type=script&lang=js"
export * from "./Amelia.vue?vue&type=script&lang=js"
import style0 from "./Amelia.vue?vue&type=style&index=0&id=7c74d5de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports